var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKomiLogoFooter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 18,
    viewBox: "0 0 54 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_739_800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.0002 5.14844H49.1758V17.6865H54.0002V5.14844Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4941 11.5024V11.3321C12.4941 7.56597 15.2412 4.83496 19.3415 4.83496C23.4417 4.83496 26.1922 7.55916 26.1922 11.3321V11.5024C26.1922 15.272 23.4451 17.9996 19.3415 17.9996C15.2378 17.9996 12.4941 15.272 12.4941 11.5024ZM21.3338 11.5024V11.3321C21.3338 9.37755 20.8272 8.41044 19.3551 8.41044C17.8829 8.41044 17.3797 9.37755 17.3797 11.3321V11.5024C17.3797 13.4604 17.8863 14.4241 19.3551 14.4241C20.8238 14.4241 21.3338 13.4604 21.3338 11.5024Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3008 17.6864V5.14835H31.8736L31.996 7.05867C32.3427 6.38041 32.8719 5.81276 33.5237 5.41983C34.1756 5.0269 34.9241 4.82435 35.6848 4.83506C37.5174 4.83506 38.8195 5.48546 39.4723 7.05867C39.8785 6.3669 40.4615 5.79615 41.1614 5.40528C41.8612 5.01441 42.6524 4.81757 43.4535 4.83506C46.6596 4.83506 47.7951 6.91226 47.7951 9.83394V17.6864H42.9809V10.7295C42.9809 9.25505 42.4268 8.5808 41.5564 8.5808C40.5364 8.5808 39.9653 9.27889 39.9653 11.1143V17.6864H35.1409V10.7533C35.1409 9.30271 34.6819 8.5808 33.7809 8.5808C32.8799 8.5808 32.1388 9.20739 32.1388 11.0428V17.6864H27.3008Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45983 5.14551H13.6684L9.68038 11.4179L13.6684 17.6903H8.45983L4.67578 11.4179C5.93373 9.32713 7.19508 7.23631 8.45983 5.14551Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8244 0H0V17.8774H4.8244V0Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0007 4.1067H49.1797V0H54.0007L53.1813 2.0227L54.0007 4.1067Z",
    fill: "#121212"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_739_800"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKomiLogoFooter);
export default __webpack_public_path__ + "static/media/komi-logo-footer.ab2cb1f8.svg";
export { ForwardRef as ReactComponent };